<template>
  <div class="my_work">
    <div class="clearfix" :class="MAIN_CLASS">
      <div class="main_l">
        <div class="calendar">
          <inlineCalendar @change="onChange" :monthNames="monthNames" :weekNames="week">
            <template v-slot:day="scope">
              <div class="box" v-for="(item,index) in days" :key="index">
                <div v-if="scope.date.dateTime.format('YYYY年MM月DD日')==item" class="point"></div>
              </div>
            </template>
          </inlineCalendar>
        </div>
        <div class="clear_date">
          <div class="btn" v-if="show" @click="clear_date">清除日期选择</div>
        </div>
      </div>
      <div class="main_r">
        <div class="bread_nav clearfix">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item to="/">我的课堂</el-breadcrumb-item>
            <el-breadcrumb-item>提问详情</el-breadcrumb-item>
          </el-breadcrumb>
          <!-- 已做 -->
          <div class="look_over">
            <el-checkbox v-model="checked" @change="chaunge">只看已回答</el-checkbox>
          </div>
        </div>
        <div class="question">
          <div class="question_nav">
            <div class="question_nav_item"></div>
          </div>
          <div class="question_item" v-for="(item,index) in comment_list" :key="index">
            <div class="question_item_title clearfix">
              <span></span>
              {{item.created_at}}
            </div>
            <div class="question_item_content clearfix">
              <div class="tag huang" v-if="item.replies!=0">已回答</div>
              <div class="tag" v-else>未回答</div>
              <div class="text">{{item.content}}</div>
              <div class="btn" @click="detail_click(item.id)">查看</div>
            </div>
          </div>
        </div>
        <div class="alt_tag" v-if="alt_tag" @click="page_Click">点击加载</div>
        <div class="alt_tag" v-else>已经到底啦</div>
      </div>
    </div>
  </div>
</template>
<script>
import { MyComments } from "@/api/index";
import appConfig from '@/api/appConfig';
export default {
  data() {
    return {
      attrs: [
        {
          key: "today",
          dot: true,
          dates: new Date()
        }
      ],
      days: [],
      monthNames: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月"
      ],
      week: ["一", "二", "三", "四", "五", "六", "日"],
      checked: false,
      comment_list: [], //评论
      comment_list1: [], //评论
      MAIN_CLASS: this.GLOBAL.MAIN_CLASS, //类名
      URL_MAQIN: this.GLOBAL.PLATFORM,
      obj: {},
      show: false,
      alt_tag: true,
      page: 1,
      page_size: 10,
      replies: 0,
      timer: "",
      course_id: "",
      id: ""
    };
  },
  mounted() {
    this.$utils.banCopy()
    let obj = {};
    obj.course_id = this.$route.query.course_id;
    obj.id = this.$route.query.id;
    obj.page = this.page;
    obj.page_size = this.page_size;
    this.obj = obj;
    this.course_id = this.$route.query.course_id;
    this.id = this.$route.query.id;
    this.myComments(obj);
  },
  methods: {
    myComments(obj) {
      MyComments(obj).then(res => {
        this.comment_list = res;
        this.comment_list1 = res;
        for (let i = 0; i < this.comment_list1.length; i++) {
          this.days.push(this.comment_list1[i].created_at);
        }
      });
    },
    //   点击练习
    practice_click() {
      this.$router.push({ name: "work" });
    },
    // 选择日期

    onChange(date) {
      this.alt_tag = true;
    this.page = 1;
      let chaunge_date = date.format("YYYY-MM-DD");
      // console.log(chaunge_date);
      this.timer = chaunge_date;
      let obj = {};
      this.replies = 0;
      obj.course_id = this.course_id;
      obj.id = this.id;
      obj.page = this.page;
      obj.page_size = this.page_size;
      obj.replies = this.replies;
      obj.comment_date = this.timer;
      MyComments(obj).then(res => {
        let arr = res;

        if (arr.length == 0) {
          this.$message("该日期没有提问");
          this.alt_tag = true;
          this.comment_list = arr;
        } else {
          this.alt_tag = true;

          this.comment_list = arr;
        }
      });

      this.show = true;
    },
    clear_date() {
      this.timer=''
      this.alt_tag = true;
      this.page = 1;
      let obj = {};
      this.replies = 0;
      obj.course_id = this.course_id;
      obj.id = this.id;
      obj.page = this.page;
      obj.page_size = this.page_size;
      this.myComments(obj);
      this.show = false;
    },
    detail_click(id) {
      if(this.URL_MAQIN==1)
        window.open(`${appConfig.ShoppUrl}ask/${id}`);
      else
        this.$router.push({ path: "my_questions_d", query: { id: id } });
    },
    chaunge() {
      this.alt_tag = true;

      this.comment_list = [];
      this.page = 1;
      this.timer = "";
      if (this.checked) {
        let obj = {};
        this.replies = 1;
        obj.course_id = this.course_id;
        obj.id = this.id;
        obj.page = this.page;
        obj.page_size = this.page_size;
        obj.replies = 1;
        this.myComments(obj);
      } else {
        this.replies = 0;
        let obj = {};
        obj.course_id = this.course_id;
        obj.id = this.id;
        obj.page = this.page;
        obj.page_size = this.page_size;
        obj.replies = 0;
        this.myComments(this.obj);
      }
      // if (this.checked) {

      //   if (arr.length == 0) {
      //     this.$message({
      //       message: "暂无已回答提问",
      //       type: "warning"
      //     });
      //   }
      // } else {
      //   this.myComments(this.obj);
      // }
    },
    page_Click() {
      this.page += 1;
      let obj = {};
      obj.course_id = this.$route.query.course_id;
      obj.id = this.$route.query.id;
      obj.page = this.page;
      obj.page_size = this.page_size;
      obj.replies = this.replies;
      obj.comment_date = this.timer;

      if (this.alt_tag) {
        MyComments(obj).then(res => {
          let arr = res;
          this.comment_list = this.comment_list.concat(arr);
          if (arr.length < 1) {
            this.alt_tag = false;
          }
        });
      } else {
        return;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main_mfd {
  .main_l {
    width: 422px;
    float: left;
    .calendar {
      border-bottom: 1px solid #eee;
    }
    .clear_date {
      padding: 24px 0;
      background-color: #fff;
      .btn {
        cursor: pointer;
        width: 280px;
        height: 50px;
        background: rgba(250, 220, 30, 1);
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        margin: 0 auto;
        text-align: center;
        line-height: 50px;
      }
    }
  }
  .main_r {
    width: 913px;
    float: right;
    .bread_nav {
      background-color: #fff;
      padding: 16px 37px;
      position: relative;
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 15px;
      .Breadcrumb {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0%, -50%);
      }
      .look_over {
        position: absolute;
        right: 37px;
        top: 50%;
        transform: translate(0%, -50%);
      }
    }
    .question {
      padding: 24px 44px 60px 44px;
      background-color: #fff;
      .question_item {
        .question_item_title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 33px;
          span {
            float: left;
            display: block;
            width: 8px;
            height: 24px;
            background: rgba(250, 220, 30, 1);
            margin-right: 10px;
          }
        }
        .question_item_content {
          padding-bottom: 24px;
          border-bottom: 1px solid #eee;
          margin-bottom: 25px;
          .tag {
            width: 46px;
            height: 21px;
            background: rgba(238, 238, 238, 1);
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            text-align: center;
            line-height: 21px;
            float: left;
            margin-right: 16px;
          }
          .huang {
            color: rgba(51, 51, 51, 1);
            background: rgba(250, 220, 30, 1);
          }
          .text {
            float: left;
            width: 551px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
          }
          .btn {
            cursor: pointer;
            float: right;
            width: 72px;
            height: 25px;
            background: rgba(250, 220, 30, 1);
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            text-align: center;
            line-height: 25px;
          }
        }
      }
    }
    .alt_tag {
      cursor: pointer;
      font-size: 20px;
      line-height: 40px;
      text-align: center;
    }
  }
}

.point {
  width: 6px;
  height: 6px;
  background: rgba(254, 76, 75, 1);
  border-radius: 50%;
  position: absolute;
  top: 8px;
  right: 16px;
}
.main_kjc {
  .main_l {
    width: 422px;
    float: left;
    .calendar {
      border-bottom: 1px solid #eee;
    }
    .clear_date {
      padding: 24px 0;
      background-color: #fff;
      .btn {
        cursor: pointer;
        width: 280px;
        height: 50px;
        background: #0cd56d;
        border-radius: 8px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        margin: 0 auto;
        text-align: center;
        line-height: 50px;
      }
    }
  }
  .main_r {
    width: 913px;
    float: right;
    .bread_nav {
      background-color: #fff;
      padding: 16px 37px;
      position: relative;
      border-radius: 4px;
      border: 1px solid rgba(238, 238, 238, 1);
      margin-bottom: 15px;
      .Breadcrumb {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0%, -50%);
      }
      .look_over {
        position: absolute;
        right: 37px;
        top: 50%;
        transform: translate(0%, -50%);
      }
    }
    .question {
      padding: 24px 44px 60px 44px;
      background-color: #fff;
      .question_item {
        .question_item_title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          margin-bottom: 33px;
          span {
            float: left;
            display: block;
            width: 8px;
            height: 24px;
            background: #0cd56d;
            margin-right: 10px;
          }
        }
        .question_item_content {
          padding-bottom: 24px;
          border-bottom: 1px solid #eee;
          margin-bottom: 25px;
          .tag {
            width: 46px;
            height: 21px;
            background: rgba(238, 238, 238, 1);
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            text-align: center;
            line-height: 21px;
            float: left;
            margin-right: 16px;
          }
          .huang {
            color: #fff;
            background: #0cd56d;
          }
          .text {
            float: left;
            width: 551px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 22px;
          }
          .btn {
            cursor: pointer;
            float: right;
            width: 72px;
            height: 25px;
            background: #0cd56d;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
            color: #fff;
            text-align: center;
            line-height: 25px;
          }
        }
      }
    }
    .alt_tag {
      cursor: pointer;
      font-size: 20px;
      line-height: 40px;
      text-align: center;
    }
  }
}
</style>
<style lang="scss">
.main_mfd {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: rgba(250, 220, 30, 1);
    border: 2px solid rgba(250, 220, 30, 1);
  }
}
.main_kjc {
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background: rgba(12, 213, 109, 1);
    border: 2px solid rgba(12, 213, 109, 1);
  }
}
.el-checkbox__inner::after {
  top: 0;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333;
}
.m-calendar .m-toolbar .m-month-selector {
  width: 37px !important;
}
</style>